import React, { useContext } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2 } from '@mui/material';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import JsxParser from 'react-jsx-parser';
import { getTextsGql } from '../screens/checkout/gql';
import { LayoutContext } from '../stores/LayoutStore';

export default function TextModal({ type, open, setOpen }) {
  const { t } = useTranslation('texts');
  const layoutContext = useContext(LayoutContext);

  const { data, loading } = useQuery(getTextsGql, {
    skip: !open || !layoutContext?.slug,
    variables: {
      slug: layoutContext?.slug,
    },
  });

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
    >
      <DialogTitle>{t(type)}</DialogTitle>
      <DialogContent>
        {loading ? (
          <Grid2 sx={{ width: '100%', textAlign: 'center', minWidth: '200px' }}>
            <CircularProgress />
          </Grid2>
        ) : (
          <DialogContentText>
            <JsxParser jsx={data?.getTexts?.texts?.[type]?.text} autoCloseVoidElements />
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}
